import { render, staticRenderFns } from "./RevitDemo.vue?vue&type=template&id=d18826d6&scoped=true"
import script from "./RevitDemo.vue?vue&type=script&lang=js"
export * from "./RevitDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18826d6",
  null
  
)

export default component.exports